import { SubscriptionDetails } from '@addmile/backend-client';
import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { useSubscriptionsTable } from './useSubscriptionsTable';

interface SubscriptionsTableProps {
  subscriptions: SubscriptionDetails[];
}

const SubscriptionsTable = ({ subscriptions }: SubscriptionsTableProps) => {
  const { data, columns } = useSubscriptionsTable(subscriptions);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-4 bg-white shadow-md rounded-xl bg-white-100 max-w-screen-xl overflow-x-auto">
      <table className="table-auto w-full border-collapse">
        <thead className="bg-gray-100 text-left">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  className="px-4 py-2 text-base text-black border-b-2 border-primary-20 font-semibold"
                  style={{ minWidth: header.getSize() }}
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(header.column.columnDef.header, header.getContext())}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id} className={`hover:bg-gray-50`}>
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="px-4 py-2 text-base font-medium"
                    style={{ minWidth: cell.column.getSize() }}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SubscriptionsTable;
